import React from 'react';
interface SocialIconProps {
  size?: number;
}
// Custom social icons with real brand colors
export const socialLinks = [{
  name: 'WhatsApp',
  href: 'https://wa.me/17185824903',
  color: '#25D366',
  Icon: ({
    size = 24
  }: SocialIconProps) => <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" data-id="element-180">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-181" />
      </svg>
}, {
  name: 'Instagram',
  href: 'https://www.instagram.com/jpbarbermobilesupply?igsh=MTByMDNwNzBhc3F0dg%3D%3D&utm_source=qr',
  color: '#E4405F',
  Icon: ({
    size = 24
  }: SocialIconProps) => <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" data-id="element-182">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" data-id="element-183" />
      </svg>
}, {
  name: 'Facebook',
  href: 'https://www.facebook.com/profile.php?id=61589616894235',
  color: '#1877F2',
  Icon: ({
    size = 24
  }: SocialIconProps) => <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" data-id="element-184">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-185" />
      </svg>
}, {
  name: 'TikTok',
  href: 'https://tiktok.com/@JPBarberSupply',
  color: '#000000',
  bgColor: '#ffffff',
  Icon: ({
    size = 24
  }: SocialIconProps) => <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" data-id="element-186">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005.8 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1.84-.1z" data-id="element-187" />
      </svg>
}, {
  name: 'YouTube',
  href: 'https://youtube.com/@JPBarberSupply',
  color: '#FF0000',
  Icon: ({
    size = 24
  }: SocialIconProps) => <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" data-id="element-188">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" data-id="element-189" />
      </svg>
}, {
  name: 'Twitter',
  href: 'https://x.com/JPBarberSupply',
  color: '#000000',
  bgColor: '#ffffff',
  Icon: ({
    size = 24
  }: SocialIconProps) => <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" data-id="element-190">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-191" />
      </svg>
}];
export function SocialIcons({
  size = 22,
  variant = 'colored'
}: {
  size?: number;
  variant?: 'colored' | 'monochrome';
}) {
  return <div className="flex flex-wrap gap-3" data-id="element-192">
      {socialLinks.map(social => {
      const {
        Icon
      } = social;
      return <a key={social.name} href={social.href} target="_blank" rel="noopener noreferrer" aria-label={social.name} className="group relative flex items-center justify-center w-11 h-11 rounded-full bg-barber-dark border border-white/10 transition-all duration-300 hover:scale-110 hover:border-transparent overflow-hidden" style={{
        ['--brand-color' as any]: social.color
      }} data-id="element-193">
            <span className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{
          backgroundColor: social.color
        }} data-id="element-194" />
            <span className="relative z-10 text-gray-400 group-hover:text-white transition-colors duration-300" style={{
          color: variant === 'colored' ? undefined : undefined
        }} data-id="element-195">
              <Icon size={size} data-id="element-196" />
            </span>
          </a>;
    })}
    </div>;
}